import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BaseService } from './base.service';
import { ResponseResult } from '../models/response-result';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HtMenuService extends BaseService {

    constructor(http: HttpClient, injector: Injector) {
        super(http, injector, `${environment.apiDomain.dapFoodEndPoint}/HtMenu`);
    }
    getByIdPhanHe(idPhanHe: number, idCha: number): Promise<ResponseResult> {
        const url = `${this.serviceUri}/GetByIdPhanHe?idPhanHe=${idPhanHe}&idCha=${idCha}`;
        return this.defaultGet(url);
    }

    // Nhóm phân hệ đang hoạt động của mọi app, kèm PhanQuyen menu cấp 1 để FE lọc theo quyền
    getsNhomPhanHe(): Promise<ResponseResult> {
        const url = `${this.serviceUri}/GetsNhomPhanHe`;
        return this.defaultGet(url);
    }

    getsNhomPhanHeQuanTri(phanHe: number): Promise<ResponseResult> {
        const url = `${this.serviceUri}/GetsNhomPhanHeQuanTri?phanHe=${phanHe}`;
        return this.defaultGet(url);
    }

    saveNhomPhanHe(item: any): Promise<ResponseResult> {
        const url = `${this.serviceUri}/SaveNhomPhanHe`;
        return this.defaultPost(url, item);
    }

    deleteNhomPhanHe(id: number): Promise<ResponseResult> {
        const url = `${this.serviceUri}/DeleteNhomPhanHe/${id}`;
        return this.defaultDelete(url);
    }

    getsMenuCap1(phanHe: number): Promise<ResponseResult> {
        const url = `${this.serviceUri}/GetsMenuCap1?phanHe=${phanHe}`;
        return this.defaultGet(url);
    }

    ganNhomPhanHe(id: number, maNhomPhanHe: string): Promise<ResponseResult> {
        const url = `${this.serviceUri}/GanNhomPhanHe`;
        return this.defaultPost(url, { id: id, maNhomPhanHe: maNhomPhanHe });
    }

    getDetailById(id: number): Promise<ResponseResult> {
        const url = `${this.serviceUri}/GetDetailById?id=${id}`;
        return this.defaultGet(url);
    }

    searchTree(phanHeId: number, trangThai: number): Promise<ResponseResult> {
        const url = `${this.serviceUri}/searchTree?phanHeId=${phanHeId}&trangThai=${trangThai}`;
        return this.defaultGet(url);
    }
    deleteCustom(id: number): Promise<ResponseResult> {
        const url = `${this.serviceUri}/deleteCustom/${id}`;

        return this._http.put<ResponseResult>(url, { id: id })
            .pipe(catchError((err: HttpErrorResponse) => this.handleError(err, this._injector)))
            .toPromise();
    }

    pinMenuItem(idMenu: number): Promise<ResponseResult> {
        const url = `${this.serviceUri}/PinMenuItem?menuId=${idMenu}`;
        return this._http
            .post<ResponseResult>(url, null)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }

    getsPinMenu(idPhanHe: number): Promise<ResponseResult> {
        const url = `${this.serviceUri}/GetsPinMenu?phanHeId=${idPhanHe}`;
        return this.defaultGet(url);
    }

    unPinMenuItem(idMenu: number): Promise<ResponseResult> {
        const url = `${this.serviceUri}/UnPinMenuItem?id=${idMenu}`;
        return this._http
            .post<ResponseResult>(url, null)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }
}

